import React from 'react';
import { PropTypes } from 'prop-types';

import { Icon } from '@ontruck/orc';

import Holidays from 'components/Recurring/Holidays';

const Header = ({ className, title, info, holidaysInfo, needsHolidays }) => (
  <div className={className}>
    <div className="icon-container">
      <Icon glyph="recurring" size="48px" color="grey700" />
    </div>
    <div>
      <h1>{title}</h1>
      <p>{info}</p>
      <p>{holidaysInfo}</p>

      {needsHolidays && <Holidays />}
    </div>
  </div>
);

Header.propTypes = {
  className: PropTypes.string,
  title: PropTypes.string,
  info: PropTypes.string,
  holidaysInfo: PropTypes.string,
  needsHolidays: PropTypes.bool,
};

Header.defaultProps = {
  className: '',
  title: '',
  info: '',
  holidaysInfo: '',
  needsHolidays: true,
};

export default Header;
